<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="会员名称">{{detailObject.member_name}}</el-descriptions-item>
				<el-descriptions-item label="订单编号">{{detailObject.order_id}}</el-descriptions-item>
				<el-descriptions-item label="购买用户">{{detailObject.user_name}}</el-descriptions-item>
				<el-descriptions-item
					label="购买类型">{{detailObject.type==1?'首次升级':detailObject.type==2?'自动续费':detailObject.type==3?'手动升级':"手动续费"}}</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>订单信息</h4>
			</div>
			<el-table :data="tableData" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" style="width: 100%">
				<el-table-column prop="member_name" label="会员名称" align="center">
				</el-table-column>
				<el-table-column prop="name" label="会员价格" align="center">
					<template slot-scope="scope">
						{{scope.row.pay_type==1?scope.row.score:'￥'+scope.row.price}}
					</template>
				</el-table-column>
				<el-table-column prop="last_member_name" label="用户原始会员" align="center">
				</el-table-column>
				<el-table-column prop="address" label="抵扣优惠" align="center">
					<template slot-scope="scope">
						{{scope.row.pay_type==1?scope.row.score-scope.row.score_cost:scope.row.price-scope.row.price_cost}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="支付方式" align="center">
					<template slot-scope="scope">
						{{scope.row.pay_type==1?'积分':'微信'}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="支付金额" align="center">
					<template slot-scope="scope">
						{{scope.row.pay_type==1?scope.row.score_cost:'￥'+scope.row.price_cost}}
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 200px;" plain @click="goBack">返回</el-button>
		</el-card>


	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getMemberOrderDetail
	} from "@/api/orders"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				tableData: [],
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
			};
		},
		components: {
			CommonPagination,
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			if (uuid) {
				this.getMemberOrderDetail(uuid);
			}
		},
		methods: {
			handlePageChange(page) {
				this.page_index = page
				this.getDoubao()
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			async getAiApplicationHistoryList() {
				let postData = {
					page_size: this.page_size1,
					page_index: this.page_index1,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getAiApplicationHistoryList(postData);
				if (status !== 200) return;
				this.hisLists = data.result.data;
				this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getMemberOrderDetail(uuid) {
				const {
					data,
					status
				} = await getMemberOrderDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
					this.tableData.push(this.detailObject)
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
			async disableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await disableUser(postData);
				if (status !== 200) return;
				await this.getMemberOrderDetail(this.detailObject.user_id);
			},

			async ableUser() {
				let postData = {
					user_id: this.detailObject.user_id
				}
				const {
					status,
					data
				} = await ableUser(postData);
				if (status !== 200) return;
				await this.getMemberOrderDetail(this.detailObject.user_id);
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}

	::v-deep .el-descriptions-item__label {
		width: 15% !important;
	}

	::v-deep .el-descriptions-item__cell {
		color: #000;
	}
</style>